import { Trans } from '@lingui/react/macro';

import { ArticleWithRelations } from '@/models/request';

import { BaseMessage } from './BaseMessage';

export const ServiceChoiceStepMessage = ({ article }: { article: ArticleWithRelations }) => {
  if (
    article.snapshot.serviceChoice === 'care-repair' &&
    article.workshop &&
    !article.workshopAcceptedAt &&
    !article.dispatchProposalSubmittedAt
  ) {
    return (
      <BaseMessage
        title={
          <Trans id="article.step.service-choice.workshop-validation.title">
            Waiting for workshop validation
          </Trans>
        }
        message={
          article.workshop?.workshopConfig?.nonDigitalized ? (
            <Trans id="article.step.service-choice.workshop-validation.on-behalf.text">
              The store will contact the workshop in order to validate the job on its behalf.
            </Trans>
          ) : (
            <Trans id="article.step.service-choice.workshop-validation.text">
              The workshop is analysing the item to determine if it can handle it.
            </Trans>
          )
        }
        article={article}
      />
    );
  }

  if (article.snapshot.serviceChoice === 'care-repair' && !!article.dispatchProposalSubmittedAt) {
    return (
      <BaseMessage
        title={
          <Trans id="article.step.service-choice.dispatch-proposal.title">
            Waiting for quote review
          </Trans>
        }
        message={
          <Trans id="article.step.service-choice.dispatch-proposal.text">
            The quote proposal is being reviewed.
          </Trans>
        }
        article={article}
      />
    );
  }

  if (
    article.snapshot.serviceChoice === 'exchange' &&
    !article.exchangeStockAvailabilityConfirmedAt
  ) {
    return (
      <BaseMessage
        title={
          <Trans id="article.step.service-choice.exchange-stock-availability.title">
            Waiting for stock confirmation
          </Trans>
        }
        article={article}
        message={
          <Trans id="article.step.service-choice.exchange-stock-availability.message">
            The stock location has been notified to review the exchange request and reserve the
            item.
          </Trans>
        }
      />
    );
  }

  return (
    <BaseMessage
      title={<Trans id="article.step.service-choice.title">Waiting for diagnosis</Trans>}
      article={article}
      message={
        <Trans id="article.step.service-choice.message">
          The brand is reviewing the item in order to select the most suitable service and actions
          to provide.
        </Trans>
      }
    />
  );
};
